// extracted by mini-css-extract-plugin
module.exports = {"chart":"styles_chart__1D0uW","donutWrapper":"styles_donutWrapper__3KC23","donut":"styles_donut__3xuZt","donutLegend":"styles_donutLegend__2gFam"};